import { useLocation } from 'react-router-dom';
import { extractPathParts } from '@/routing';

export const useLocationPath = (): Array<string> => {
  const { pathname } = useLocation();
  return extractPathParts(pathname);
};
